// chaves que estão sendo manipuladas através desta utils
// ao salvar nesta constante, se garante que seja a mesma em todo o sistema
// garante também que outros devs não irão sobrescrevê-las se as virem aqui
// e que você não passará 2 horas debugando uma chave que você escreveu errado sem querer
export const LOCAL_STORAGE_KEYS = {
  SIDEDRAWER_ANSWERING_DIALER_CALL_DATA: 'sidedrawer::answeringDialerCallData',
  SIDEDRAWER_PROTOCOL_RECORD_TYPE_ID: 'sidedrawer::protocolRecordTypeId',
  SIDEDRAWER_PROTOCOL_FORM_VALUES: 'sidedrawer::protocolFormValues',
  CONFIG_CHAT_MAX_PULL_CHAT: 'config::chatMaxPullChat',
  USER_ALLOWED_QUEUES: 'queues',
  MONITORING_SCREEN_CHAT_STAT_CARDS_STATE: 'monitoringScreenChat::cardStats',
  MONITORING_UNIFIED_QUEUES_TABLE: 'monitoringUnified::queuesTable',
  SUPERVISOR_PANEL_CHAT: 'supervisorPanel:chat',
  CONVERSATION_REPORT_TABLE: 'monitoringDetails:table',

  MONITORING_PANEL_SORT_TYPE: 'monitoringPanel::sortType',
  MONITORING_PANEL_IS_ONE_CARD_PER_AGENT: 'monitoringPanel::isOneCardPerAgent',
  MONITORING_PANEL_FILTER_VALUE: 'monitoringPanel::filterValue',
  MONITORING_PANEL_SHOW_AGENT_STATISTICS:
    'monitoringPanel::showAgentStatistics',
  MONITORING_PANEL_GROUP_BY_QUEUE: 'monitoringPanel::groupByQueue',
  MONITORING_PANEL_SELECTED_GROUP: 'monitoringPanel::selectedGroup',
  MONITORING_PANEL_MANUAL_SELECTION: 'monitoringPanel::manualSelection',
  MONITORING_PANEL_VOICE_CHANNELS: 'monitoring_panel_voice_channels',

  MONITORING_CHAT_SELECTED_GROUP: 'monitoringChat::selectedGroup',
  MONITORING_CHAT_MANUAL_SELECTION: 'monitoringChat::manualSelection',
  MONITORING_CHAT_LAYOUT_OPTION: 'monitoringChat::layoutOption',
  MONITORING_CHAT_SORT_OPTION: 'monitoringChat::sortOption'
};
/**
 * Salva um objeto no localStorage sob a key fornecida
 * @param {string} key a string que servirá como chave no localStorage
 * @param {Object} obj o objeto que se deseja salvar
 */
export function saveObjectToLocalStorage(key, obj) {
  try {
    return localStorage.setItem(key, JSON.stringify(obj));
  } catch (error) {
    console.error('Erro ao salvar um objeto no localStorage:', error);
    return null;
  }
}

/**
 * Salva um objeto no localStorage sob a key fornecida
 * @param {string} key a string que servirá como chave no localStorage
 */
export function loadObjectFromLocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    console.error('Erro ao carregar um objeto do localStorage:', error);
    return null;
  }
}
